import { render, staticRenderFns } from "./DriverDetailAdminConfig.vue?vue&type=template&id=5ead4f70&scoped=true&"
import script from "./DriverDetailAdminConfig.vue?vue&type=script&lang=js&"
export * from "./DriverDetailAdminConfig.vue?vue&type=script&lang=js&"
import style0 from "./DriverDetailAdminConfig.vue?vue&type=style&index=0&id=5ead4f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ead4f70",
  null
  
)

export default component.exports